/* Account and Learn screens
 *
 * Moved verbatim from currencykeep_2026-08-03.html, lines 798-866.
 * The body below is byte-identical to the original; only the import
 * block above and the export block below were added. (Phase 1, Step 2.)
 */

import { $, save, state, totals } from './state.js'
import { authRows } from './views-auth.js'

/* ⚠ THE USERNAME IS TEXT — his ruling 2026-10-04: the client cleans it to
 * [a-z0-9_] (`setUsername`), but nothing in the database constrains it
 * (filed in the register), so the account line escapes it. */
const escH=s=>String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
function vAccount(){
  const owned=state.collection.length;const FREE=10;
  const pct=Math.min(100,Math.round(owned/FREE*100));const over=owned>=FREE;
  const priv=`<div class="privacy">
        ${state.editingName
          ? `<input id="unameInput" class="unameinput" placeholder="choose a username" value="${escH(state.username||"")}" maxlength="20" autocomplete="off">`
          : (state.username
             ? `<button class="pname" data-editname>@${escH(state.username)} <span class="pen">\u270e</span></button>`
             : `<button class="pname" data-editname style="color:var(--muted)">Set a username to share \u203a</button>`)}
        <button class="toggle ${state.isPublic?"on":""}" data-togglepublic ${state.username?"":"disabled"} aria-label="Public or private"><span class="knob"></span></button>
        <span class="pstate ${state.isPublic?"pub":""}">${state.isPublic?"Public":"Private"}</span>
      </div>`;
  return `<div style="padding-top:8px"></div>
    <div class="rowhead"><h2>Account</h2></div>
    <div class="acard">
      <div class="acard-h">Profile</div>
      ${priv}
      <div class="fieldhint">Your username and public/private setting control how you appear in the Community. Add a logo &amp; banner from the Community tab.</div>
    </div>
    <div class="acard">
      <div class="acard-h">Membership</div>
      <div class="planrow"><span class="planname">Free plan</span><span class="planbadge">Current</span></div>
      <div class="usage"><div class="usage-bar"><span style="width:${pct}%"></span></div>
        <div class="usage-txt">${owned} of ${FREE} free notes used${over?" \u2014 limit reached":""}</div></div>
      ${over?`<div class="upsell">You've reached the free limit. Upgrade to keep adding notes to your vault.</div>`:``}
      <div class="acard-h" style="margin-top:18px">Upgrade options</div>
      <div class="plans">
        <div class="plan"><div class="pt">Monthly</div><div class="pp">Pricing TBD</div><div class="pd">Unlimited notes, billed monthly.</div></div>
        <div class="plan best"><div class="ptag">Best value</div><div class="pt">Yearly</div><div class="pp">Pricing TBD</div><div class="pd">Unlimited notes, save vs monthly.</div></div>
      </div>
      <button class="btn" data-soon="Subscriptions are coming soon" style="margin-top:14px">Manage subscription</button>
      <div class="fieldhint">Pricing is being finalized \u2014 Currency Keep is free up to ${FREE} notes.</div>
    </div>
    <div class="acard">
      <div class="acard-h">Help &amp; support</div>
      <button class="arow" data-nav="learn"><span>Learn &amp; FAQ</span><span class="arow-x">\u203a</span></button>
      <button class="arow" data-soon="Support contact is coming soon"><span>Contact support</span><span class="arow-x">\u203a</span></button>
      <button class="arow" data-soon="Problem reporting is coming soon"><span>Report a problem</span><span class="arow-x">\u203a</span></button>
    </div>
    <div class="acard">
      <div class="acard-h">Settings</div>
      <button class="arow" data-soon="Collection export is coming soon"><span>Export my collection</span><span class="arow-x">\u203a</span></button>
      <button class="arow" data-soon="Currency Keep \u2014 a vault for U.S. paper currency"><span>About Currency Keep</span><span class="arow-x">\u203a</span></button>
      ${authRows()}
    </div>
    <div class="hint">Currency Keep \u00b7 early access</div>`;
}
function vLearn(){
  const faq=[
    ["Is Currency Keep free?","Yes \u2014 you can build and track a vault of up to 10 notes for free, and browse the full Resources catalog anytime. Beyond 10 notes, a membership keeps you adding."],
    ["Where do the catalog values come from?","Notes are organized by Friedberg number and shown by grade, so you can see roughly what a note is worth in the condition you own. For notes with no listed value (such as Obsolete notes), you enter your own market value."],
    ["Can other people see what I paid?","No. Your cost basis, appraisals, and totals are always private. When your collection is public, other collectors see which notes you own \u2014 never values or what you paid."],
    ["How do I add a note to my vault?","Open Resources, find the note (search by Fr#, denomination, type, or state), tap it, then add it to your vault. From there you set its grade, cost, photos, and your own appraisal."],
    ["Are my photos private?","Your note photos are yours. If you make your collection public, the front image can appear on your public profile next to the note; otherwise it stays private to you."],
    ["What are the logo and banner for?","They personalize your public profile in the Community \u2014 your logo replaces the default avatar, and your banner appears at the top of your collection when other collectors view it."]
  ];
  return `<div style="padding-top:8px"></div>
    <div class="rowhead"><h2>Learn</h2></div>
    <div class="learn-intro">A quick guide to how Currency Keep works \u2014 and answers to common questions.</div>
    <div class="acard-h">Features</div>
    <div class="feat"><div class="feat-t">Your Vault</div><div class="feat-d">Track every note you own \u2014 estimated value, what you paid, and your gain or loss, updated as you set grades and appraisals.</div></div>
    <div class="feat"><div class="feat-t">Resources catalog</div><div class="feat-d">The full Friedberg-organized catalog. Search by Fr#, denomination (e.g. \u201c5000\u201d), type, state, or series to find any note.</div></div>
    <div class="feat"><div class="feat-t">Grades &amp; value</div><div class="feat-d">Pick your note's grade to see its value in that condition. For notes with no listed price, enter your own market value.</div></div>
    <div class="feat"><div class="feat-t">Photos</div><div class="feat-d">Add front and back photos and crop/straighten them in the built-in editor. Your front photo becomes the note's preview.</div></div>
    <div class="feat"><div class="feat-t">Community</div><div class="feat-d">Make your collection public to share which notes you own, browse other collectors, and personalize your profile with a logo and banner.</div></div>
    <div class="acard-h" style="margin-top:20px">Frequently asked questions</div>
    ${faq.map(f=>`<details class="faq"><summary>${f[0]}</summary><div class="faq-a">${f[1]}</div></details>`).join("")}
    <div class="hint">More answers will appear here as the Currency Keep community grows.</div>`;
}

export {
  vAccount,
  vLearn,
}
